import service from '@/service'
import urlManager from '@/urlManager'

/**
 * This is the mixins for billing. It contains functions to fetch billing, product info
 */
export default {
  methods: {
    async fetchProducts() {
      return (await service.client.get(urlManager.billingProducts)).data
    },
    async fetchSubscription(orgId) {
      try {
        return (await service.client.get(urlManager.billingSubscription(orgId))).data
      } catch (e) {
        if (e.response && e.response.status === 404) {
          console.log('Ignoring subscription 404')
          return null
        } else {
          throw e
        }
      }
    },
    async fetchActiveSubscription(orgId) {
      const response = await service.client.get(urlManager.activeSubscription(orgId))
      return response.data
    },
    isFreeSubscription(subscription) {
      return subscription.prices?.every(price => !+price.unitAmount)
    }
  }
}
